
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"lime-stroke",attrs:{"fill":"none","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round","stroke-miterlimit":"10","d":"M6.5 21.5h-5v-13h5v13zm-2.51-15h-.029c-1.511 0-2.488-1.182-2.488-2.481 0-1.329 1.008-2.412 2.547-2.412 1.541 0 2.488 1.118 2.519 2.447C6.538 5.354 5.561 6.5 3.99 6.5zm11.51 6a2 2 0 00-2 2v7h-5s.059-12 0-13h5v1.485s1.548-1.443 3.938-1.443c2.962 0 5.062 2.144 5.062 6.304V21.5h-5v-7a2 2 0 00-2-2z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}})])
          )
        }
      }
    